import React from 'react';

import { req, useApiGet, useApiLoading } from 'react-reqq-lite';

import * as c from './contants';
import * as actions from './actions';

export const useValidateOrder = () => {
  const isApiLoading = useApiLoading(c.VALIDATE_ORDER, 'get');
  const validate = React.useCallback((order_number, callback) => {
    actions.validateOrder(order_number, callback);
  }, []);
  return [isApiLoading, validate];
};

export const useValidateOTP = () => {
  const isApiLoading = useApiLoading(c.VALIDATE_ORDER, 'get');
  const validate = React.useCallback((order_number, params, callback) => {
    actions.validateOTP(order_number, params, callback);
  }, []);
  return [isApiLoading, validate];
};

export const useGetOrderDetails = (order_number, params) => {
  const isApiLoading = useApiLoading(c.GET_ORDER_DETAILS, 'get');
  const data = useApiGet(c.GET_ORDER_DETAILS, {});
  React.useEffect(() => {
    if (order_number && params?.pin) {
      actions.getOrderDetails(order_number, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_number, JSON.stringify(params)]);

  React.useEffect(
    () => () => {
      req.set(c.GET_ORDER_DETAILS, {});
    },
    []
  );
  return [isApiLoading, data];
};

export const useConfirmOrder = () => {
  const isApiLoading = useApiLoading(c.CONFIRM_ORDER, 'put');
  const confirm = React.useCallback((order_number, callback) => {
    actions.confirmOrder(order_number, callback);
  }, []);
  return [isApiLoading, confirm];
};

export const useDeliveredOrder = () => {
  const isApiLoading = useApiLoading(c.DELIVERED_ORDER, 'put');
  const confirm = React.useCallback((order_number, callback) => {
    actions.deliveredOrder(order_number, callback);
  }, []);
  return [isApiLoading, confirm];
};
